// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ButtonsGroup_buttonContainer__TJXVo","saveButton":"ButtonsGroup_saveButton__ebw5O","cancelButton":"ButtonsGroup_cancelButton__8gTDy"};